<template>
    <div class="h-full">
        <fixed-list :dataSource="dataSource" :config="config" @onDataSourceChange="onDataSourceChange" @onPageChange="initialize" :configurable="false" :queryParam="queryParam">
            <el-table ref="customerListTable" slot="elList" :data="dataSource.Result" border @selection-change="handleSelectionChange" @current-change="handleCurrentChange" highlight-current-row>
                <el-table-column v-for="(col,index)  in columns"
                                 :key="index"
                                 :prop="col.FieldName"
                                 :label="col.DisplayName"
                                 :render-header="bindFilter(queryParam,col)"
                                 :fixed="index==0&&(!config||!config.isDetailDisplay)"
                                 :min-width="(!config||!config.isDetailDisplay)?parseInt(col.Width):0">
                    <template slot-scope="scope">
                        <el-button v-if="col.FieldName==='CustomerCode'" type="text"  style="text-decoration:underline;color:#1874CD;cursor:pointer">{{ scope.row[col.FieldName] }}</el-button>
                        <span v-else>{{ displayValue(col, scope.row) }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </fixed-list>
    </div>
</template>
<script>
    export default {
        mounted() {
            this.initialize();//加载表格数据
        },
        data() {
            return {
                config: {
                    isDetailDisplay: false,
                },
                multipleSelection: [],
                queryParam: {
                    PageIndex: 1,
                    PageSize: 10,
                    params: {}
                },
                dataSource: {
                    ColDefs: {},
                    Result: [],
                    TotalCount: 0
                },
            }
        },
        props: {
            addressType: 0,
            selectCondition: {
               
            }
        },
        computed: {
            // 本弹窗要求补充展示的信息（后端 ColDefs 里不含这三列）
            extraColumns: function () {
                return [
                    { FieldName: "AddressType", DisplayName: "地址类型", Width: 110, Sortable: false, Filterable: false },
                    { FieldName: "SupplierType", DisplayName: "收发货方类型", Width: 130, Sortable: false, Filterable: false },
                    { FieldName: "CompanyName", DisplayName: "收发货方名称", Width: 200, Sortable: false, Filterable: false }
                ];
            },
            // 后端列配置里对本弹窗无用/取不到值的列，直接不展示
            hiddenFields: function () {
                return ["GetDisplayAddressName", "DisplayIsDefaultAddress", "getDisplayCompanyName"];
            },
            // 后端返回的列 + 本弹窗补充的 3 列（插在"创建时间"之前，保证顺序稳定）
            columns: function () {
                var _this = this;
                var body = (this.dataSource.ColDefs && this.dataSource.ColDefs.BodyFieldParams) || [];
                if (body.length === 0) return [];
                var cols = body.filter(function (col) {
                    return col.Visible !== false && _this.hiddenFields.indexOf(col.FieldName) < 0;
                });
                var exist = {};
                cols.forEach(function (col) { exist[col.FieldName] = true; });
                var extras = this.extraColumns.filter(function (col) { return !exist[col.FieldName]; });
                var index = -1;
                for (var i = 0; i < cols.length; i++) {
                    if (cols[i].FieldName === "CreatedTime") { index = i; break; }
                }
                if (index < 0) index = cols.length;
                var result = cols.slice(0, index).concat(extras).concat(cols.slice(index));
                if (this.config && this.config.isDetailDisplay) {
                    result = result.slice(0, 4);
                }
                return result;
            }
        },
        watch: {
            // 发货人/收货人切换时打开弹窗会重设 addressType，按新的地址类型重新查询
            addressType: function () {
                this.queryParam.PageIndex = 1;
                this.initialize();
            }
        },
        methods: {
            handleCurrentChange: function (val) {
                this.$emit("onSelectedRow", val);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 枚举值转中文：地址类型 100发货地址/200收货地址；收发货方类型 100收货方/200发货方
            displayValue: function (col, row) {
                var value = row ? row[col.FieldName] : null;
                if (col.FieldName === "AddressType") {
                    if (value == 100) return "发货地址";
                    if (value == 200) return "收货地址";
                    return "";
                }
                if (col.FieldName === "SupplierType") {
                    if (value == 100) return "收货方";
                    if (value == 200) return "发货方";
                    return "";
                }
                return value === undefined || value === null ? "" : value;
            },
            onDataSourceChange(ds) {
                var _this = this;
                _this.dataSource = {
                    ColDefs: {
                        BodyFieldParams: []
                    },
                    Result: [],
                    TotalCount: 0
                };
                _this.$nextTick(function () {
                    _this.dataSource = ds;

                });
            },
            initialize: function () {
                if (this.selectCondition) {
                    this.Utils.extend(this.queryParam.params, this.selectCondition);
                }
                // 发货人信息只查发货地址、收货人信息只查收货地址（后端已按 AddressType 过滤，无需前端传条件）
                var url = this.addressType == 100
                    ? "omsapi/customeraddress/searchsenderaddresslist"
                    : "omsapi/customeraddress/searchreceiveaddresslist";
                var _this = this;
                this.$ajax.query(url, "post", _this.queryParam, (result) => {
                    _this.dataSource = result;
                });
            },
        },

    }
</script>
